import { TransactionsState } from "./types";

export const defaultState = (): TransactionsState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    transactions: [],
    links: {}
  };
};

export const state = defaultState();
